// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__aSA3o","location":"Header_location__1veAy"};